import { Pipe, PipeTransform } from '@angular/core';
import { eachDayOfInterval, isValid, toDate } from 'date-fns';
import { DateRangeMode } from '@ag-common-lib/public-api';

@Pipe({ name: 'lockedDates' })
export class LockedDatesPipe implements PipeTransform {
  transform(start: Date, end: Date, mode: DateRangeMode = DateRangeMode.strict): Date[] {
    if (!isValid(toDate(start)) || !isValid(toDate(end))) {
      return [];
    }

    if (mode === DateRangeMode.shoulder) {
        if (new Date(start).getTime() === new Date(end).getTime()) {
          return [];
        }

        const days = eachDayOfInterval({ start, end });
        // Remove the first and last days to allow shoulder to touch but not overlap
        return days.slice(1, -1);
    }
    return eachDayOfInterval({
      start,
      end,
    });
  }
}
